import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root'
})
export class EstadoDocumentoService {


  constructor(
    private gqlclient: GraphQLClient
  ) { }

  obtenerEstadoDocumento(callback: Function) {
    const inputParams = {
      entidad:{
        tipo_dte_codigo: 2
      }
    }

    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: estado_documentoInputType) {
          estado_documento {
            obtenerSegunFiltro(filtro: {exacto: $entidad}) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                registros {
                  codigo
                  nombre
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.estado_documento.obtenerSegunFiltro
        callback({ mensajes, respuesta })
      }
    );
  }

}
